import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  globalCss: {
    "html, body": {
      bg: "bg.canvas",
      color: "fg",
    },
    "table, [data-tabular]": {
      fontVariantNumeric: "tabular-nums",
    },
  },
  theme: {
    tokens: {
      colors: {
        brand: {
          50: { value: "#edf8f0" },
          100: { value: "#d4efdd" },
          200: { value: "#abdfbd" },
          300: { value: "#78c995" },
          400: { value: "#4cb46f" },
          500: { value: "#2e9e4f" },
          600: { value: "#238742" },
          700: { value: "#15713a" },
          800: { value: "#145b31" },
          900: { value: "#114a29" },
          950: { value: "#082e19" },
        },
      },
      fonts: {
        heading: {
          value:
            'Geist, Inter, "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, sans-serif',
        },
        body: {
          value:
            'Geist, Inter, "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, sans-serif',
        },
      },
    },
    recipes: {
      button: {
        base: {
          transitionDuration: "fast",
          transitionTimingFunction: "ease-out",
          "&:active:not(:disabled)": { transform: "scale(0.96)" },
        },
      },
    },
    semanticTokens: {
      shadows: {
        card: {
          value: {
            _light:
              "0px 0px 0px 1px oklch(0 0 0 / 0.06), 0px 1px 2px -1px oklch(0 0 0 / 0.06), 0px 2px 4px 0px oklch(0 0 0 / 0.04)",
            _dark: "0 0 0 1px oklch(1 0 0 / 0.08)",
          },
        },
        stickyEdge: {
          value: {
            _light: "-10px 0 12px -10px oklch(0 0 0 / 0.16)",
            _dark: "-10px 0 12px -10px oklch(0 0 0 / 0.6)",
          },
        },
      },
      radii: {
        l2: { value: "{radii.md}" },
        l3: { value: "{radii.lg}" },
      },
      colors: {
        brand: {
          solid: {
            value: {
              _light: "{colors.brand.600}",
              _dark: "{colors.brand.500}",
            },
          },
          contrast: { value: "white" },
          fg: {
            value: {
              _light: "{colors.brand.700}",
              _dark: "{colors.brand.300}",
            },
          },
          muted: {
            value: {
              _light: "{colors.brand.100}",
              _dark: "{colors.brand.900}",
            },
          },
          subtle: {
            value: {
              _light: "{colors.brand.50}",
              _dark: "{colors.brand.950}",
            },
          },
          emphasized: {
            value: {
              _light: "{colors.brand.200}",
              _dark: "{colors.brand.800}",
            },
          },
          focusRing: { value: "{colors.brand.500}" },
        },
        bg: {
          canvas: { value: { _light: "#f5f7fa", _dark: "#0b0c0e" } },
          sidebar: { value: { _light: "white", _dark: "{colors.gray.950}" } },
        },
      },
    },
  },
});

export const system = createSystem(defaultConfig, config);
